/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Near_TextInputs */

const en_highlight_settings_near_text = /** @type {(inputs: Highlight_Settings_Near_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Near text`)
};

const es_highlight_settings_near_text = /** @type {(inputs: Highlight_Settings_Near_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca del texto`)
};

/**
* | output |
* | --- |
* | "Near text" |
*
* @param {Highlight_Settings_Near_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_near_text = /** @type {((inputs?: Highlight_Settings_Near_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Near_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_near_text(inputs)
	return en_highlight_settings_near_text(inputs)
});